<template>
  <k-panel>
    <template v-slot:left-buttons>
      <k-tabs large>
        <k-tab v-if="$is_privilege(['root', 'developer'])" name="settings" to="/settings/settings/list" label="Settings"></k-tab>
        <k-tab v-if="$is_admin()" name="list_types" to="/settings/list_types" label="List Types"></k-tab>
        <k-tab v-if="$is_admin()" name="external_devices" to="/settings/external_devices/" label="External devices">
          <template #submenu>
            <div>
              <k-btn tile style="width: 100%; text-align: left;" flat to="/settings/external_devices/videohub">Videohub</k-btn>
            </div>
            <div>
              <k-btn tile style="width: 100%; text-align: left;" flat to="/settings/external_devices/teranex">Teranex</k-btn>
            </div>
            <div>
              <k-btn tile style="width: 100%; text-align: left;" flat to="/settings/external_devices/pdu">PDU</k-btn>
            </div>
          </template>
        </k-tab>

        <k-tab name="profile" to="/settings/profile" label="Profile">
          <template #submenu>
            <div>
              <k-btn tile to="/settings/profile" flat style="width: 100%; text-align: left;">Profile</k-btn>
            </div>
            <div>
              <k-btn tile to="/settings/profile/sessions" flat style="width: 100%; text-align: left;">Sessions</k-btn>
            </div>
          </template>
        </k-tab>

        <k-tab v-if="!$is_admin()" name="sessions" to="/settings/sessions" label="Sessions"></k-tab>
        <k-tab v-if="$is_admin()" name="accounts" to="/settings/accounts" label="Accounts"></k-tab>
        <k-tab v-if="$is_admin()" name="groups" to="/settings/groups" label="Groups"></k-tab>
        <k-tab v-if="$is_privilege(['root', 'developer'])" name="maintenance" to="/settings/maintenance" label="Maintenance"></k-tab>
      </k-tabs>

    </template>
    <router-view></router-view>
  </k-panel>
</template>

<script>
import { mapGetters } from 'vuex'
import Settings from './settings/Settings.vue'
import ListTypes from './settings/ListTypes.vue'
import Profile from './settings/Profile.vue'
import Sessions from './settings/Sessions.vue'
import Accounts from './settings/Accounts.vue'
import Groups from './settings/Groups.vue'
import RunningOrders from './settings/RunningOrders.vue'
import Maintenance from './settings/Maintenance.vue'
import ExternalDevices from './settings/ExternalDevices.vue'

export default {
  routes: [
    {
      path: "",
      redirect: "profile"
    },
    {
      path: 'settings',
      component: Settings,
      children: Settings.routes
    },
    {
      path: 'list_types',
      component: ListTypes,
      children: ListTypes.routes
    },
    {
      path: "running_orders",
      component: RunningOrders,
      children: RunningOrders.routes
    },
    {
      path: "maintenance",
      component: Maintenance,
      meta: {search: false}
    },
    {
      path: "external_devices",
      component: ExternalDevices,
      children: ExternalDevices.routes
    },
    {
      path: 'profile',
      name: "Profile",
      component: Profile,
      meta: {search: false}
    },
    {
      path: 'profile/sessions',
      name: "ProfileSessions",
      component: Sessions,
      meta: {search: false}
    },

    {
      path: 'accounts',
      component: Accounts,
      children: Accounts.routes
    },
    {
      path: 'groups',
      component: Groups,
      children: Groups.routes
    },
    {
      path: 'sessions',
      name: "Sessions",
      component: Sessions,
      meta: {search: false}
    }
  ]
}
</script>

<style>
</style>
